import { apiInstance } from '@/api/instance';
import { AppApiError } from '@/utils/error';
import { translateFile } from '@/i18n';

export interface PresignedUrlRequest {
  fileName: string;
  fileType: string;
  fileSize: number;
  /** S3 key prefix; the portal uses `partners` (contract: partners-contract.md). */
  folder?: string;
}

interface PresignedUrlResponse {
  uploadUrl: string;
  fields: Record<string, string>;
  key: string;
  publicUrl: string;
  maxSizeBytes: number;
}

export interface UploadFileRequest extends PresignedUrlResponse {
  file: File;
}

export const filesApi = {
  presignedUrl: (data: PresignedUrlRequest) =>
    apiInstance.post<PresignedUrlResponse>('files/upload-url', data),

  uploadFile: async (data: UploadFileRequest) => {
    const formData = new FormData();
    Object.entries(data.fields).forEach(([key, value]) => {
      formData.append(key, value);
    });
    formData.append('file', data.file);

    const response = await fetch(data.uploadUrl, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok && response.status !== 204) {
      throw new AppApiError({
        message: `S3 upload failed: ${response.status}`,
        userMessage: translateFile('api.routes.common.files.api', 'error'),
        status: response.status,
        raw: response,
      });
    }

    return response;
  },
};
